import script from "./HelpBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./HelpBlock.vue?vue&type=script&lang=ts&setup=true"

import "./HelpBlock.vue?vue&type=style&index=0&id=09e4d3c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09e4d3c8"]])

export default __exports__